import React from "react";
import "./Css/Gramsabha.css";

import img3 from "./Images/Ganpati1.jpg";   
import img2 from "./Images/Ganpati2.jpg";   
import img1 from "./Images/Ganpati3.jpg";   
import img4 from "./Images/Ganpati4.jpg";   
import img5 from "./Images/ganpati.jpg";  


export default function Ganpati() {
  return (
    <section className="gramsabha-section">
      <h2 className="gramsabha-title">पर्यावरणपूरक गणेशोत्सव जनजागृती आणि अंमलबजावणी तसेच प्रमाणपत्र वाटप</h2>

      <div className="gramsabha-layout">

        {/* LEFT BIG IMAGE */}
        <div className="item item1">
          <img src={img1} alt="" />
         
          
        </div>

        {/* TOP RIGHT - 2 IMAGES */}
        <div className="item item2">
          <img src={img2} alt="" />
        </div>

        <div className="item item3">
          <img src={img3} alt="" />
        </div>

        {/* CENTER BIG IMAGE */}
        <div className="item item4">
          <img src={img4} alt="" />
        </div>

        {/* RIGHT IMAGE */}
        <div className="item item5">
          <img src={img5} alt="" />
        </div>
      </div>
    </section>
  );
}
